import { useState, useEffect } from "react";
import { ImageOff } from "lucide-react";
import api from "@/lib/api";

export const AuthImage = ({ src, alt = "", className = "" }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    let blobUrl;
    setUrl(null);
    setFailed(false);
    api.get(src, { responseType: "blob" })
      .then((r) => {
        blobUrl = URL.createObjectURL(r.data);
        if (active) setUrl(blobUrl);
      })
      .catch(() => active && setFailed(true));
    return () => {
      active = false;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [src]);

  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-muted text-muted-foreground ${className}`}>
        <ImageOff className="h-5 w-5" />
      </div>
    );
  }
  if (!url) return <div className={`bg-muted animate-pulse ${className}`} />;
  return <img src={url} alt={alt} className={className} />;
};
